/* =============================================================
   Vitarium custom.js
   - Augustus-actie 2026: gratis-product-ladder in de winkelwagen
   - Verwijdert zichzelf na 31 aug 2026 (epoch-gate)
   - Rendert NIET als de liquid-versie (.cart-gratisproduct) er al staat
   ============================================================= */
(function () {
  'use strict';
  function init() {
    try {
      if (Date.now() >= 1788213600000) return; // na 31 aug 2026: niets doen
      if (!/(^|\/)cart\/?$/.test(location.pathname)) return;
      if (document.querySelector('.cart-gratisproduct')) return;

      var TIERS = [
        { min: 3000, vid: 53687627481435, naam: 'Houten maatschepje' },
        { min: 4500, vid: 47289749373275, naam: 'Chiazaad 175 gram' },
        { min: 6000, vid: 46788453466459, naam: 'Jodium tabletjes' }
      ];
      var geld = function (c) { return '\u20AC' + (c / 100).toFixed(2).replace('.', ','); };

      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        if (document.querySelector('.cart-gratisproduct')) return;
        var vids = cart.items.map(function (i) { return i.variant_id; });

        var box = document.createElement('div');
        box.className = 'cart-gratisproduct';
        box.style.cssText = 'margin:10px 0 14px 0;padding:14px 18px;border:1px solid #d9c98f;border-radius:8px;background:#111111;';
        var html = '<p style="margin:0 0 6px 0;font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:#c9b36a;">\uD83C\uDF81 Augustus-actie: kies je gratis product</p>';
        TIERS.forEach(function (t) {
          html += '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;padding:7px 0;border-top:1px solid #2c2c2c;">';
          html += '<span style="font-size:13px;color:#ffffff;"><strong>' + t.naam + '</strong> <span style="color:#8f8a7d;">v.a. ' + geld(t.min).replace(',00', '') + '</span></span>';
          if (cart.total_price >= t.min) {
            if (vids.indexOf(t.vid) > -1) {
              html += '<span style="font-size:12px;font-weight:700;color:#c9b36a;">\u2713 gekozen \u2014 wordt gratis bij afrekenen</span>';
            } else {
              html += '<button type="button" class="gratisproduct-add" data-vid="' + t.vid + '" style="cursor:pointer;background:#c9b36a;color:#161616;border:0;border-radius:4px;font-size:12px;font-weight:700;padding:6px 12px;white-space:nowrap;">GRATIS toevoegen</button>';
            }
          } else {
            html += '<span style="font-size:12px;color:#8f8a7d;white-space:nowrap;">nog ' + geld(t.min - cart.total_price) + ' te gaan</span>';
          }
          html += '</div>';
        });
        html += '<p style="margin:6px 0 0 0;font-size:11px;color:#8f8a7d;">Kies er 1 \u2014 max. 1 gratis product per bestelling \u00B7 t/m 31 augustus</p>';
        box.innerHTML = html;

        var anker = document.querySelector('.cart-actions');
        if (anker && anker.parentNode) { anker.parentNode.insertBefore(box, anker); }
        else {
          var m = document.querySelector('#MainContent') || document.querySelector('main');
          if (m) { m.insertBefore(box, m.firstChild); } else { return; }
        }

        box.addEventListener('click', function (ev) {
          var btn = ev.target && ev.target.closest ? ev.target.closest('.gratisproduct-add') : null;
          if (!btn) return;
          btn.disabled = true; btn.textContent = '...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(btn.getAttribute('data-vid'), 10), quantity: 1 })
          }).then(function (r) {
            if (r.ok) { location.reload(); }
            else { btn.disabled = false; btn.textContent = 'GRATIS toevoegen'; }
          }).catch(function () { btn.disabled = false; btn.textContent = 'GRATIS toevoegen'; });
        });
      }).catch(function () {});
    } catch (e) {}
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
